import axios from "axios";
import { apiUrl, imageHandler } from "./env";
import Router from "vue-router";

const apiInstance = axios.create({
  baseURL: apiUrl,
  timeout: 10000,
});

const apiService = {
  imageHandler(url, width, height, quality = 80) {
    if (/.*undefined.*/.test(url)) {
      const basePath =
        Router.app && Router.app.$router
          ? Router.app.$router.options.base
          : "/cms/";
      return `${basePath}static/img/content/no-image.png`;
    }
    return `${imageHandler}/${width}/${height}/${quality}/${url}`;
  },

  getCarriers(productId) {
    return apiInstance.get(`/product/${productId}`);
  },
  // user methods
  loginUser(data) {
    return apiInstance.post("/user/login", data);
  },
  forgotPassword(email) {
    return apiInstance.get(`/user/forgot-password?email=${email}`);
  },
  getUsers(userToken) {
    return apiInstance({
      method: "GET",
      url: "/user",
      headers: {
        Authorization: userToken,
      },
    });
  },
  getUserById(userToken, id) {
    return apiInstance({
      method: "GET",
      url: `/user/detail/${id}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  createUser(userToken, data) {
    return apiInstance({
      method: "PUT",
      url: "/user",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  setUser(userToken, data) {
    return apiInstance({
      method: "PUT",
      url: "/user",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  deleteUser(userToken, ids) {
    return apiInstance({
      method: "DELETE",
      url: "/user",
      headers: {
        Authorization: userToken,
      },
      data: { idList: ids },
    });
  },

  // integrator
  checkSubscription(userToken, msisdn, product) {
    return apiInstance({
      method: "GET",
      url: `/integrator/${msisdn}/${product}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  unsubscribe(userToken, msisdn, product) {
    return apiInstance({
      method: "POST",
      url: `/integrator/${msisdn}/${product}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
};

export default {
  install(Vue) {
    Vue.$apiService = apiService;
    Vue.prototype.$apiService = apiService;
  },
};



// WEBPACK FOOTER //
// ./src/services/global.js